var path = 'visualizer/views/gridHeaderRow.html';
var html = "<div ng-style=\"{ height: col.headerRowHeight }\" ng-repeat=\"col in renderedColumns\" ng-class=col.colIndex() class=ngHeaderCell> <div ng-header-cell></div> </div>";
window.angular.module('templates-visualizer').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;